import styled from 'styled-components';

const Container = styled.div`
  max-width: 1280px;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100vw;
  margin: auto;
`;

export default Container;
